import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { httpRequestsOnSuccessActions, invoiceActions, invoicePaymentActions } from 'store';
import { AccordionFullTable, CustomDelete, SelectActions } from 'components';
import { NumericFormat } from 'react-number-format';
import { Skeleton } from '@mui/material';
import { FindLoad, FindSuccessItem, formatNumberToFix, Images, useModal } from 'utils';
import { GET_ACTION_TYPE, invoiceStatusEnums, pendingInvoiceTableInfo, SUBMIT_INVOICES_TYPE, DELETE_INVOICES_BULK_TYPE } from './constants';

export const PendingInvoices = () => {
    const invoicePaymentsData = useSelector((state) => state.invoicePayment.invoicePayments);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open, close } = useModal();
    const [selectedList, setSelectedList] = useState([]);
    const submitSuccess = FindSuccessItem(SUBMIT_INVOICES_TYPE);
    const deleteSuccess = FindSuccessItem(DELETE_INVOICES_BULK_TYPE);
    const loader = FindLoad(GET_ACTION_TYPE);
    const invoices = invoicePaymentsData?.invoices || [];
    const totalPendingInvoices = invoices.length;
    const totalPendingAmount = invoices.reduce((sum, inv) => sum + (inv?.totalAMT || 0), 0);

    const renderParams = () => {
        const pushInfo = {
            ...info,
            statuses: [invoiceStatusEnums.PENDING],
        };
        delete pushInfo.page;
        delete pushInfo.tabType;
        delete pushInfo.clientFull;
        pushInfo.skip = info?.skip ? info?.skip : 0;
        pushInfo.limit = 50;
        return pushInfo;
    };

    const getInvoices = (load) => {
        dispatch(invoicePaymentActions.getInvoicePayments({ ...renderParams() }, load));
    };

    useEffect(() => {
        getInvoices();
    }, [info]);

    useEffect(() => {
        if (submitSuccess) {
            getInvoices('noLoad');
            setSelectedList([]);
            dispatch(httpRequestsOnSuccessActions.removeSuccess(SUBMIT_INVOICES_TYPE));
        }
        if (deleteSuccess) {
            getInvoices('noLoad');
            setSelectedList([]);
            dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_INVOICES_BULK_TYPE));
        }
    }, [submitSuccess, deleteSuccess]);

    const handleCheck = (ev, item, name) => {
        ev.stopPropagation();
        ev.preventDefault();
        if (name === 'all') {
            setSelectedList(
                invoicePaymentsData?.invoices?.length === selectedList?.length
                    ? []
                    : invoicePaymentsData?.invoices?.map((i) => i?.id)
            );
        } else {
            setSelectedList((prev) =>
                prev.includes(item?.id) ? prev.filter((id) => id !== item?.id) : [...prev, item?.id]
            );
        }
    };

    const removeSelectedList = () => {
        setSelectedList([]);
    };

    const handleSubmit = () => {
        dispatch(invoiceActions.submitInvoices(selectedList));
    };

    const handleDelete = (item) => {
        const isBulk = !item;
        const ids = isBulk ? selectedList : [item?.id];

        open(
            <CustomDelete
                info={isBulk ? 'Delete Pending Invoices?' : 'Delete Pending Invoice?'}
                text={
                    isBulk
                        ? 'Are you sure you want to delete the selected pending invoices? Bills will be moved back to Invoiceable Appts.'
                        : 'Are you sure you want to delete this pending invoice? Bills will be moved back to Invoiceable Appts.'
                }
                handleDel={() => dispatch(invoiceActions.deleteInvoicesBulk(ids, invoiceStatusEnums.PENDING))}
                actionType={DELETE_INVOICES_BULK_TYPE}
                afterSuccess={() => {
                    close();
                    getInvoices('noLoad');
                    if (isBulk) setSelectedList([]);
                }}
                body={
                    !isBulk && (
                        <div className="deleting-client-info-box" style={{ alignItems: 'flex-start' }}>
                            <img style={{ marginTop: 4 }} src={Images.authFile} alt="icon" />
                            <p style={{ fontWeight: 600 }}>{item?.displayId || '--'}</p>
                        </div>
                    )
                }
                innerText="Delete"
            />
        );
    };

    const handleAction = (item, name) => {
        if (name === 'delete') {
            handleDelete(item);
        }
    };

    return (
        <div>
            {/*{loader?.length ? (*/}
            {/*    <div style={{ margin: '24px 0 6px 0' }}>*/}
            {/*        <Skeleton variant="rectangular" width={'100%'} height={60} style={{ borderRadius: '8px' }} />*/}
            {/*    </div>*/}
            {/*) : (*/}
            {/*    <div className="aging-section-box" style={{ justifyContent: 'flex-end', margin: '24px 0 6px 0' }}>*/}
            {/*        <div className="billing-total-row">*/}
            {/*            <p className="billing-total-title">Pending Invoices</p>*/}
            {/*            <div className="billing-total-price-row">*/}
            {/*                <span>{totalPendingInvoices}</span>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div className="billing-total-row">*/}
            {/*            <p className="billing-total-title">Pending Amount</p>*/}
            {/*            <div className="billing-total-price-row">*/}
            {/*                <NumericFormat*/}
            {/*                    value={formatNumberToFix(totalPendingAmount)}*/}
            {/*                    displayType={'text'}*/}
            {/*                    thousandSeparator={true}*/}
            {/*                    prefix={'$'}*/}
            {/*                />*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*)}*/}

            {!!selectedList?.length && (
                <SelectActions
                    submitText={'Submit'}
                    submitBtnIcon={Images.addCircle}
                    actionType={SUBMIT_INVOICES_TYPE}
                    selectedList={selectedList?.length}
                    selectAll={handleCheck}
                    submitClaims={handleSubmit}
                    removeSelected={removeSelectedList}
                    renderOtherBtns={
                        <button onClick={() => handleDelete()} className="red-trash-btn">
                            <img src={Images.redTrashLine} alt="delete" />
                        </button>
                    }
                />
            )}

            <AccordionFullTable
                margin={'12px 0 0 0'}
                tableInfo={pendingInvoiceTableInfo(navigate, info, handleCheck, handleAction, invoicePaymentsData?.invoices, selectedList)}
                list={invoicePaymentsData?.invoices}
                listCount={invoicePaymentsData?.count}
                detailPage={(item) => `/invoice/${item?.id}`}
                selectedList={selectedList}
            />
        </div>
    );
};
